export const tokens = {
  'text-primary': '#21282b',
  'text-secondary': '#5a5e60',
  'text-minor': '#919395',
  'text-invert': '#ffffff',
  'text-secondary-invert': '#ffffffbf',
  'text-minor-invert': '#ffffff80',
  'background-primary': '#ffffff',
  'background-secondary': '#f5f4f1',
  'background-accent': '#21282b',
  'control-primary': '#21282b',
  'control-secondary': '#d8d4c9',
  'control-minor': '#ebe9e3',
  'control-invert': '#ffffff',
  'control-secondary-invert': '#ffffffbf',
  'control-minor-invert': '#ffffff80',
  'control-accent': '#fdc300',
  'control_hover-primary': '#000000',
  'control_hover-secondary': '#b2a994',
  'control_hover-minor': '#d8d4c9',
  'control_hover-primary-invert': '#ffffffbf',
  'control_hover-secondary-invert': '#ffffff80',
  'control_hover-minor-invert': '#ffffff40',
  'control_hover-accent': '#dfa000',
  'success-primary': '#49a941',
  'success-dark': '#357931',
  'success-light': '#c2ebbf',
  'brand-primary': '#fdc300',
  'brand-dark': '#bf8900',
  'brand-light': '#f9e28d',
  'brand-minor': '#21282b',
  'brand-invert': '#ffffff',
  'accent-primary': '#faf351',
  'accent-dark': '#a6a433',
  'accent-light': '#fdf9b2',
  'attention-primary': '#c85952',
  'attention-dark': '#9c4944',
  'attention-light': '#f0dad8',
  'b2b-primary': '#a36a47',
  'b2b-dark': '#863914',
  'b2b-light': '#dfcdc0',
  'secondary-green_primary': '#a0b9b1',
  'secondary-green_dark': '#6a8c81',
  'secondary-green_light': '#d0ddd8',
  'secondary-blue_primary': '#8385cb',
  'secondary-blue_dark': '#545390',
  'secondary-blue_light': '#d6e7f8',
  'secondary-orange_primary': '#d95e00',
  'secondary-orange_dark': '#ad4b00',
  'secondary-orange_light': '#f7decc',
  'secondary-purple_primary': '#89527d',
  'secondary-purple_dark': '#6e1454',
  'secondary-purple_light': '#d7c5d3',
  'secondary-yellow_primary': '#faf351',
  'secondary-yellow_dark': '#a6a433',
  'secondary-yellow_light': '#fdf9b2',
  'secondary-red_primary': '#b82825',
  'secondary-red_dark': '#801916',
  'secondary-red_light': '#e7cac8',
  'secondary-black': '#21282b',
  'secondary-white': '#ffffff',
  'service-primary': '#4aa3e7',
  'service-dark': '#446298',
  'service-light': '#d6e7f8'
};